import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import APIClient from './APIClient';
import Header from './Header';

import Home from './Home';
import RegisterForm from './RegisterForm';
import ConfirmForm from './ConfirmForm';
import LoginForm from './LoginForm';
import ForgottenPasswordForm from './ForgottenPasswordForm';
import ResetPasswordForm from './ResetPasswordForm';
import ProfileForm from './ProfileForm';
import LogOut from './LogOut';
import NotFound from './NotFound';

class Router extends React.Component {
  header = React.createRef();

  routes = [
    {
      title: 'Home',
      path: '/',
      exact: true,
      component: Home,
      requireAuth: false,
    },
    {
      title: 'Sign Up',
      path: '/register',
      component: RegisterForm,
      requireAuth: false,
    },
    {
      path: '/confirm',
      component: ConfirmForm,
    },
    {
      title: 'Log In',
      path: '/log-in',
      component: LoginForm,
      requireAuth: false,
      props: () => ({
        setLoggedIn: this.setLoggedIn,
      }),
    },
    {
      path: '/forgotten',
      component: ForgottenPasswordForm,
    },
    {
      path: '/reset',
      component: ResetPasswordForm,
    },
    {
      title: 'Your Comics',
      path: '/',
      exact: true,
      component: Home,
      requireAuth: true,
    },
    {
      title: 'Profile',
      path: '/profile',
      component: ProfileForm,
      requireAuth: true,
    },
    {
      title: 'Log Out',
      path: '/log-out',
      component: LogOut,
      requireAuth: true,
      props: () => ({
        setLoggedIn: this.setLoggedIn,
      }),
    },
    {
      path: '*',
      component: NotFound,
    },
  ];

  state = {
    loggedIn: APIClient.shared.hasToken(),
  };

  setLoggedIn = (loggedIn) => {
    this.setState({ loggedIn });
  };

  render() {
    const navRoutes = this.routes.filter(r => r.requireAuth === undefined || r.requireAuth === this.state.loggedIn);

    return (
      <BrowserRouter>
        <div>
          <Header ref={this.header} routes={navRoutes} />
          <Switch>
            {this.routes.map(route => (
              <Route
                key={route.path}
                path={route.path}
                render={(props) => {
                  if (route.props) {
                    props = Object.assign(props, route.props());
                  }

                  return React.createElement(route.component, props);
                }}
                exact={route.exact}
              />
            ))}
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}

export default Router;



// WEBPACK FOOTER //
// ./src/Router.js